<template>
  <div class="authWrapper new-login-wrapper rest-password-container">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <router-link to="/verify-identity"> <h6 class="login-highlight">Back</h6></router-link>
            <div class="rep-icon-login">
              <img
                src="../../../assets/images/group-icon.svg"
                alt="image-fluid"
              />
            </div>
            <h4 class="login-title mb-2">Reset Password OTP</h4>
            <div class="auth-form pt-1 pb-3">
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(changePassword)">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required|strong_password"
                    name="New Password"
                    vid="newpassword"
                  >
                    <b-form-group
                      label="New Password"
                      label-for="input-1"
                      :state="errors.length || formErrorFlag ? false : null"
                    >
                      <div
                        class="changeForm-group errorIcon_eye position-relative"
                      >
                        <b-form-input
                          class="no-bg-icon"
                          id="input-1"
                          :type="newPasswordType"
                          v-model="newpassword"
                          :state="errors.length || formErrorFlag ? false : null"
                          placeholder="Enter your new password"
                          @input="onPasswordInput"
                        ></b-form-input>
                        <eye-form-button
                          id="newpassword"
                          hideOnDefault="false"
                          :value="newpassword"
                          class="rest-toggle-eye-icon"
                          type="text"
                          @toggle="toggleNewPasswordVisibility"
                        ></eye-form-button>
                        <b-form-invalid-feedback>
                          <div>{{ errors[0] || (formErrorFlag ? formErrors["error"] : '') }}</div>
                        </b-form-invalid-feedback>
                      </div>
                    </b-form-group>
                  </ValidationProvider>

                  <b-form-group label=" " label-for="">
                    <div>
                      <password-strength-bar
                        @updateScore="setPasswordScore"
                        :password="newpassword"
                      ></password-strength-bar>
                    </div>
                  </b-form-group>

                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required|confirmed:newpassword"
                    name="Re-Type New Password"
                  >
                    <b-form-group
                      label="Re-Type New Password"
                      label-for="input-2"
                      :state="errors.length || formErrorFlag ? false : null"
                    >
                      <div
                        class="changeForm-group position-relative"
                        :class="errors.length || formErrorFlag ? 'errorIcon_eye' : ''"
                      >
                        <b-form-input
                          class="no-bg-icon"
                          id="input-2"
                          :type="reTypePasswordType"
                          :state="errors.length || formErrorFlag ? false : null"
                          v-model="confirmpassword"
                          placeholder="Re-Type New Password"
                        ></b-form-input>
                        <eye-form-button
                          id="reTypepassword"
                          hideOnDefault="false"
                          :value="confirmpassword"
                          class="rest-toggle-eye-icon"
                          type="text"
                          @toggle="toggleReTypePasswordVisibility"
                        ></eye-form-button>
                        <b-form-invalid-feedback>
                          <div>{{ errors[0] || (formErrorFlag ? formErrors["error"] : '') }}</div>
                        </b-form-invalid-feedback>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                  <button
                    class="submit-btn mt-3 next-btn"
                    :disabled="verifyLoader"
                    type="submit"
                  >
                    <b-spinner v-if="verifyLoader" small></b-spinner>
                    Change Password
                  </button>
                </b-form>
              </ValidationObserver>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding">
          <Logincarsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logincarsoule from "./Logincarsoule";
import axios from "axios";
import { mapGetters } from "vuex";
import helper from "@/resource/Helper";
import PasswordStrengthBar from "./PasswordStrengthBar.vue";
import EyeFormButton from "../../../components/form/EyeFormButton.vue";
import { extend } from 'vee-validate';
import { required, confirmed } from 'vee-validate/dist/rules';

extend('strong_password', {
  validate: (value) => {
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    return value.length >= 8 && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
  },
  message: 'Password should be at least 8 characters long and include uppercase, lowercase, number & special character.'
});

extend('required', required);
extend('confirmed', confirmed);

export default {
  name: "ResetPassword",
  components: {
    Logincarsoule,
    PasswordStrengthBar,
    EyeFormButton
  },
  data() {
    return {
      loader: false,
      newpassword: "",
      confirmpassword: "",
      formErrorFlag: false,
      formErrors: { error: '' },
      verifyLoader: false,
      passwordScore: 0,
      newPasswordType: 'password',
      isNewPasswordVisible: true,
      reTypePasswordType: 'password',
      isReNewPasswordVisible: true,
    };
  },
  methods: {
    toggleNewPasswordVisibility() {
      this.isNewPasswordVisible = !this.isNewPasswordVisible;
      this.newPasswordType = this.isNewPasswordVisible ? "text" : "password";
    },
    toggleReTypePasswordVisibility() {
      this.isReNewPasswordVisible = !this.isReNewPasswordVisible;
      this.reTypePasswordType = this.isReNewPasswordVisible ? "text" : "password";
    },
    changePassword() {
      if (this.passwordScore < 60) {
        this.formErrorFlag = true;
        this.formErrors.error = "Please use a stronger password.";
        return;
      }
      if (!this.$refs.observer.validate()) {
        this.formErrorFlag = true;
        this.formErrors.error = this.$refs.observer.errors[0] || "Validation failed.";
        return;
      }

      this.verifyLoader = true;
      let url = process.env.VUE_APP_API_URL_V3 + `auth/set-new-password`;
      let app = this;

      const email = app.$store.getters.groupEmail;
      const device_id = app.$store.getters.deviceId || app.$uuid.v1();
      const reset_code = app.$store.getters.OTPCode || app.otp;

      const payload = {
        email: email,
        device_id: device_id,
        reset_code: reset_code,
        password: this.newpassword,
      };

      axios
        .post(url, payload)
        .then(function (response) {
          if (response.data.status == "success") {
            helper.infoMessage(app, response.data.status, response.data.message);
            helper.delayRedirect("Login", 0);
          }
        })
        .catch(function (error) {
          app.formErrorFlag = true;
          app.formErrors.error = error.response?.data?.message || "An error occurred.";
        })
        .finally(() => {
          this.verifyLoader = false;
        });
    },
    setPasswordScore(score) {
      this.passwordScore = score;
    },
    onPasswordInput(value) {
      this.resetErrorMsg(value);
    },
    resetErrorMsg(value) {
      let app = this;
      if (app.formErrorFlag && value) {
        app.formErrorFlag = false;
        app.formErrors.error = '';
        this.$refs.observer.reset(); // Reset VeeValidate errors
      }
    }
  },
  computed: {
    ...mapGetters({
      deviceId: "deviceId",
      otp: "OTPCode",
    }),
  },
  created() {
    console.log(this.$store.getters);
  }
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}

.rest-password-container .invalid-feedback {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}

.rest-password-container .error-message {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}
</style>

<style scoped>
.no-bg-icon {
  background: none !important;
}

.rest-toggle-eye-icon {
  position: absolute;
  top: 10px;
  right: 8px;
  cursor: pointer;
}
</style>